import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';

export function StartScreen() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[var(--color-bg)] px-4 md:pb-14">
      <div className="w-full max-w-sm flex flex-col items-center text-center gap-5 py-10">
        <img src="/zmist-logo.svg" alt="Zmist" className="w-20 h-20" />
        <h1 className="text-3xl font-bold m-0">Zmist</h1>
        <p className="text-black/55 dark:text-white/55 m-0">
          From mist to meaning — that's zmist.
        </p>
        <div className="flex flex-col gap-3 w-full mt-4">
          <Button variant="primary" full onClick={() => navigate('/login')}>
            Login
          </Button>
          <Button variant="bordered" full onClick={() => navigate('/register')}>
            Sign Up
          </Button>
        </div>
      </div>
    </div>
  );
}
